import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  tips: [
    'Describe qué se traslada en cada movimiento: "Equipo pesado", "Repuestos", "Combustible", "Personal".',
    'Sirve para saber qué tipo de carga concentra más viajes y qué transporte requiere cada una.',
    'Mantené la lista acotada: son categorías generales, no el detalle de cada envío.',
  ],
  nextSteps: [
    'Indicar el tipo de carga al registrar cada solicitud de logística.',
    'Consultar los informes de logística para ver la actividad agrupada por tipo de carga.',
  ],
};

const ConfiguracionCategoriasCargas = (props) => (
  <ConfiguracionBase
    apiEndpoint="categorias-cargas"
    titulo="Tipos de Carga"
    descripcion="Tipos de elementos que se transportan en movimientos logísticos"
    icon="fas fa-boxes"
    backTo="/configuracion?seccion=logistica"
    compact
    help={HELP}
    {...props}
  />
);

export default ConfiguracionCategoriasCargas;
